<img [src]="staffPhotoUrl()"  [width]="imageSize()" [height]="imageSize()" [class]="roundedClass()" (error)="onError($event)" />